import {} from "../actionTypes";

const INITIAL_STATE = {
  company: [],
  loading: false,
  error: null,
};

export default function CompanyReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    default:
      return state;
  }
}
